import React, { useEffect } from 'react';
import { filter, find, includes, map } from 'lodash';
import cogoToast from 'cogo-toast';

import GroupModal from './GroupModal';
import { initialState, reducer } from '../reducer';
import { advertisementGroupsAddHandler, advertisementGroupsSetHandler, advertisementGroupsModalHandler } from '../actions';

export const AdGroupSaveMutation = `mutation AdvertisementGroupUpdate($data: AdvertisementGroupUpdateInputType!) {
    advertisementGroupUpdate(data: $data) {
        ok
    }
  }`;

export const AdvertisementGroupsQuery = `query AdvertisementGroups{    
    advertisementGroups {
      id
      name
      isDraft
      disabled
      displayMode
    }
  }`;

export const SINGLE_DISPLAY_MODE = 'single';

export const multipleDisplayModes = [
  { key: 'stacked', value: 'Below each other' },
  { key: 'slider', value: 'In a slider' }
];

export const displayModeSummary = (displayMode) => {
  const multipleDisplayMode = find(multipleDisplayModes, (mode) => mode.key === displayMode);
  return multipleDisplayMode ? `shows all ads ${multipleDisplayMode.value.toLowerCase()}` : 'shows 1 ad';
};

export const saveAdvertisementGroup = (adGroup) =>
  fetch('/graphql', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: AdGroupSaveMutation,
      variables: {
        data: {
          id: adGroup.id,
          name: adGroup.name,
          disabled: adGroup.disabled,
          isDraft: adGroup.isDraft,
          displayMode: adGroup.displayMode
        }
      }
    })
  }).then((resp) => resp.json());

const GroupMenu = ({ advertisement, advertisements, onSelectGroup, onDeselectGroup, context }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const advertisementGroups = state.advertisementGroups;

  const fetchAdGroups = () => {
    fetch('/graphql', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ query: AdvertisementGroupsQuery })
    })
      .then((resp) => resp.json())
      .then((result) => {
        advertisementGroupsSetHandler(dispatch, result.data.advertisementGroups);
      })
      .catch((err) => {});
  };

  const handleAdGroupsModal = () => {
    advertisementGroupsModalHandler(dispatch, { ...state.adGroupsModal, isOpen: !state.adGroupsModal.isOpen });
  };

  const handleSaveAdGroup = (adGroup) => {
    saveAdvertisementGroup(adGroup)
      .then((result) => {
        if (result?.data?.advertisementGroupUpdate?.ok) {
          cogoToast.success('Advertisement Group Saved');
          advertisementGroupsAddHandler(dispatch, adGroup);
          handleAdGroupsModal();
        } else {
          const error = result && result.errors && result.errors.length > 0 ? result.errors[0].message : 'Something went wrong';
          cogoToast.error(error);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    fetchAdGroups();
  }, []);

  if (advertisementGroups.length === 0) {
    return (
      <React.Fragment>
        <div className='builder-font-bold builder-mt-4'>No groups defined.</div>
        <div className='builder-mb-4'> An advertisement will only be visible on the website if it contains a group.</div>
        <div className='builder-underline builder-font-semibold builder-cursor-pointer' onClick={handleAdGroupsModal}>
          Create new group
        </div>
        <GroupModal
          isOpen={state.adGroupsModal.isOpen}
          advertisementGroup={undefined} // TEMP Only needed when editing is required
          onSaveGroup={handleSaveAdGroup}
          onClose={() => {
            handleAdGroupsModal();
          }}
          context={context}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className='builder-mt-4'>
        {map(advertisementGroups, (group) => {
          const selected = includes(advertisement.groups, group.id);
          const groupAdvertisements = filter(advertisements, (ad) => includes(ad.groups, group.id));
          const otherPrimary = find(groupAdvertisements, (ad) => ad.isPrimary && ad.id !== advertisement.id);
          return (
            <div key={group.id} className='builder-flex builder-items-start builder-mb-2'>
              <input
                type='checkbox'
                // defaultChecked={selected}
                checked={selected}
                onChange={(e) => (selected ? onDeselectGroup(group.id) : onSelectGroup(group.id))}
                className='builder-mt-1 builder-h-4 builder-w-4 builder-text-indigo-600 focus:builder-ring-indigo-500 builder-border builder-border-gray-300 builder-rounded-md builder-cursor-pointer'
              />
              <div className='builder-flex builder-flex-col builder-ml-2'>
                <label className='builder-block builder-text-gray-900 builder-text-md'>{group.name}</label>
                <span className='builder-text-sm builder-text-gray-500'>
                  {`${groupAdvertisements.length} ad${groupAdvertisements.length === 1 ? '' : 's'}`}
                  {groupAdvertisements.length > 1 && ` · ${displayModeSummary(group.displayMode)}`}
                  {otherPrimary && ` · primary: ${otherPrimary.description}`}
                </span>
                {selected && advertisement.isPrimary && otherPrimary && <span className='builder-text-sm builder-text-red-600'>This group already has a primary advertisement.</span>}
              </div>
            </div>
          );
        })}

        <div className='builder-underline builder-font-semibold builder-cursor-pointer builder-mt-4' onClick={handleAdGroupsModal}>
          Create new group
        </div>
      </div>
      <GroupModal
        isOpen={state.adGroupsModal.isOpen}
        advertisementGroup={undefined} // TEMP Only needed when editing is required
        onSaveGroup={handleSaveAdGroup}
        onClose={() => {
          handleAdGroupsModal();
        }}
        context={context}
      />
    </React.Fragment>
  );
};

export default GroupMenu;
